import { useEffect, useState } from "react";
import styled from "styled-components";

import theme from "../../../styles/theme";
import TransparentButton from "../../../components/Common/Buttons";
import { NoDataMessage } from "../../../components/Common/TableStyles";
import { ChampionsTable, ChampionsTableSkeleton } from "./ChampionsTable";

const CHAMPIONS_VISIBLE = 6;

const ShowAllButton = styled(TransparentButton).attrs({ as: "button" })`
  margin-top: 16px;
  width: 100%;
  border: 2px solid ${theme.colors.secondaryDark};
  background: transparent;
  font-family: "Montserrat", sans-serif;
  font-size: 13px;
  font-weight: 700;
  border-radius: 0;
  justify-content: center;
  cursor: pointer;

  &:hover {
    border-radius: 0;
    border-color: ${theme.colors.gold};
  }
`;

export function ChampionsSection({ champions, loading, onSelectDriver }) {
  const [expanded, setExpanded] = useState(false);

  // Switching simulators swaps the whole list, so an expansion made against the previous one
  // should not carry over.
  useEffect(() => setExpanded(false), [champions]);

  // Ahead of the empty-state branch: an unloaded list is also an empty one, and the "ще немає
  // чемпіонів" message must not flash before the request has even answered.
  if (loading) {
    return <ChampionsTableSkeleton />;
  }

  if (!champions.length) {
    return <NoDataMessage>Ще немає чемпіонів у цьому симуляторі</NoDataMessage>;
  }

  const visible = expanded ? champions : champions.slice(0, CHAMPIONS_VISIBLE);

  return (
    <div>
      <ChampionsTable champions={visible} onSelectDriver={onSelectDriver} />

      {champions.length > CHAMPIONS_VISIBLE && (
        <ShowAllButton onClick={() => setExpanded((prev) => !prev)}>
          {expanded ? "Згорнути ↑" : `Показати всіх (${champions.length}) ↓`}
        </ShowAllButton>
      )}
    </div>
  );
}
